export default __webpack_public_path__ + "static/media/date.94249bdb.svg";